"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[58400],{

/***/ 37276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ initKakao; },
/* harmony export */   "L": function() { return /* binding */ shareKakao; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);


var initKakao = function() {
    if (window.Kakao) {
        var kakao = window.Kakao;
        if (!kakao.isInitialized()) {
            kakao.init("37d6f07b8ece67b826f25e89654bf4e1");
        }
    }
};
var shareKakao = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(linkUrl, title, description) {
        var basicTitle, basicDescription, image, sendTitle, sendDescription, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    basicTitle = "인공지능 서비스 마켓 아이소";
                    basicDescription = "이미지, 데이터 분석 등 다양한 아이소 앱을 사용해보세요.";
                    image = "https://firebasestorage.googleapis.com/v0/b/aiso-api.appspot.com/o/apps%2Fpreview%2Faiso_logo.jpg?alt=media&token=e6014be6-b135-4fdf-bac2-9e86295ffac5";
                    sendTitle = title ? title : basicTitle;
                    sendDescription = description ? description : basicDescription;
                    _tmp = {};
                    /* sendDefault */ return [
                        4,
                        window.Kakao.Link.sendDefault((_tmp.objectType = "feed", _tmp.content = {
                            title: sendTitle,
                            description: sendDescription,
                            imageUrl: image,
                            imageWidth: 1500,
                            imageHeight: 600,
                            link: {
                                mobileWebUrl: linkUrl,
                                webUrl: linkUrl
                            }
                        }, _tmp.buttons = [
                            {
                                title: "아이소로 이동하기",
                                link: {
                                    mobileWebUrl: linkUrl,
                                    webUrl: linkUrl
                                }
                            }, 
                        ], _tmp))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function shareKakao(linkUrl, title, description) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 47984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var stores_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31806);
/* harmony import */ var components_FormatDate__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(87936);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_Alert__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34950);
/* harmony import */ var components_UserPhoto__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64410);
/* harmony import */ var components_UserName__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37915);
/* harmony import */ var components_UserUid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20137);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79794);
/* harmony import */ var _material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(868);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Share__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(53093);
/* harmony import */ var _material_ui_icons_ShoppingCartOutlined__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21276);
/* harmony import */ var _material_ui_icons_ReportOutlined__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(77217);
/* harmony import */ var _material_ui_icons_ContactSupportOutlined__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84503);
/* harmony import */ var components_modal_ShareModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76195);
/* harmony import */ var components_modal_LoginModal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95547);
/* harmony import */ var components_modal_InquireModal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39696);
/* harmony import */ var components_modal_ReportModal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(49957);
/* harmony import */ var components_modal_ArchiveModal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17843);
/** @format */ // TODO: 신고하기 기능 추가하기













// Marerial Icon










var AppHeader = function(param) {
    var email = param.email, appId = param.appId, appName = param.appName, price = param.price, createdAt = param.createdAt, oneLineContent = param.oneLineContent;
    var photoUrl = (0,components_UserPhoto__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(email);
    var appUserName = (0,components_UserName__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(email);
    var userUid = (0,components_UserUid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(email);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), modalVisible1 = ref[0], setModalVisible1 = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), modalVisible2 = ref1[0], setModalVisible2 = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), modalVisible3 = ref2[0], setModalVisible3 = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loginModalVisible = ref3[0], setLoginModalVisible = ref3[1];
    // useEffect(() => {
    //   if (settings.email) {
    //     // 보관함 체크
    //     const docRef = projectFirestore.collection("gcf").doc(email).collection("app").doc(appId).collection("archive").doc(settings.email);
    //     docRef
    //       .get()
    //       .then((doc) => {
    //         if (doc.exists) {
    //           setArchive(doc.data().createdAt);
    //         }
    //       })
    //       .catch((error) => {
    //         console.log("Error getting document:", error);
    //         BasicAlert(error);
    //       });
    //   }
    // }, []);
    /* 보관함 버튼 클릭 */ // const handleClickArchive = async () => {
    //   /** 보관함 버튼 클릭하면 생성 */
    //   if (archive) {
    //     setModalVisible1(true);
    //   } else {
    //     const createdAt = FormatDate(new Date());
    //     setArchive(createdAt);
    //     try {
    //       const docRefApp = projectFirestore
    //         .collection("gcf")
    //         .doc(email)
    //         .collection("app")
    //         .doc(appId)
    //         .collection("archive")
    //         .doc(settings.email);
    //       const docRefUser = projectFirestore.collection("users").doc(settings.email).collection("archive").doc(appId);
    //       const values = {
    //         createdAt,
    //         appId: appId,
    //         appName: appName,
    //         previewInput: previewInput,
    //         previewOutput: previewOutput,
    //         price: price,
    //         email: email,
    //         userName: userName,
    //       };
    //       await docRefApp.set(values);
    //       await docRefUser.set(values);
    //       await setModalVisible1(true);
    //     } catch (error) {
    //       console.log(error);
    //       BasicAlert("보관함 생성 실패");
    //     }
    //   }
    // };
    /* Modal */ var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref4[0], setOpen = ref4[1];
    var handleOpen = function() {
        setOpen(true);
    };
    var handleClose = function() {
        setOpen(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sm:flex justify-between items-start p-3 aiso_detail_header",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-start items-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: "/user/profile/".concat(userUid),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "img-cover-box rounded-full min-w-min bg-white border-2 border-white",
                                        style: {
                                            width: "50px",
                                            height: "50px"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: photoUrl,
                                            alt: "profile",
                                            className: "w-full"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "whitespace-pre-line break-all pl-3 mt-1",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "truncate-1-lines mb-0 font-gmarket-medium text-base font-bold",
                                        children: appUserName
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mb-0 text-333 font-gmarket-medium text-sm",
                                        children: createdAt ? createdAt.substring(0, 16) : ""
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-end pt-2 sm:pt-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mr-3 hidden",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                    title: "보관함에 추가",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        color: "primary",
                                        onClick: function() {
                                            return handleClickArchive();
                                        },
                                        className: "p-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ShoppingCartOutlined__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            className: "text-333 ",
                                            fontSize: "medium"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mr-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                    title: "문의하기",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        color: "primary",
                                        onClick: function() {
                                            setModalVisible2(true);
                                        },
                                        className: "p-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ContactSupportOutlined__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            className: "text-333"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mr-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                    title: "신고하기",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        color: "primary",
                                        onClick: function() {
                                            setModalVisible3(true);
                                        },
                                        className: "p-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ReportOutlined__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            className: "text-333"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                        title: "공유하기",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            color: "primary",
                                            onClick: handleOpen,
                                            className: "p-2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Share__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                className: "text-333"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_ShareModal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        open: open,
                                        handleClose: handleClose,
                                        title: appName,
                                        description: oneLineContent
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_ArchiveModal__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                modalVisible: modalVisible1,
                setModalVisible: setModalVisible1,
                closeModal: function() {
                    return setModalVisible1(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InquireModalContent, {
                modalVisible: modalVisible2,
                setLoginModalVisible: setLoginModalVisible,
                closeModal: function() {
                    return setModalVisible2(false);
                },
                appId: appId,
                appName: appName,
                email: email,
                appUserName: appUserName,
                price: price
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReportModalContent, {
                modalVisible: modalVisible3,
                setLoginModalVisible: setLoginModalVisible,
                closeModal: function() {
                    return setModalVisible3(false);
                },
                appId: appId,
                appName: appName,
                email: email,
                appUserName: appUserName,
                price: price
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_LoginModal__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                modalVisible: loginModalVisible,
                closeModal: function() {
                    return setModalVisible1(false);
                }
            })
        ]
    });
};
/* 문의 모달 */ var InquireModalContent = function(param) {
    var modalVisible = param.modalVisible, setLoginModalVisible = param.setLoginModalVisible, closeModal = param.closeModal, appId = param.appId, appName = param.appName, email = param.email, appUserName = param.appUserName, price = param.price;
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), title = ref[0], setTitle = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), content = ref1[0], setContent = ref1[1];
    var handleModalOkButton = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(function() {
            var date, createdAt, text, text1, values, _tmp, collectionRefAppUser, newDoc, docRefUser, docRefApp, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        /* 로그인 체크하고 로그인 후 이용해달라고 하기 */ if (!settings.email) {
                            setLoginModalVisible(true);
                            return [
                                2,
                                ""
                            ];
                        }
                        date = new Date();
                        createdAt = (0,components_FormatDate__WEBPACK_IMPORTED_MODULE_22__/* .FormatDate */ .r2)(date);
                        if (title === "") {
                            text = "문의 제목을 입력해주세요.";
                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)(text);
                            return [
                                2
                            ];
                        }
                        if (content === "") {
                            text1 = "문의 내용을 입력해주세요.";
                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)(text1);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        _tmp = {};
                        values = (_tmp.email = settings.email, _tmp.userName = settings.name, _tmp.appId = appId, _tmp.appName = appName, _tmp.appEmail = email, _tmp.appUserName = appUserName, _tmp.price = price, _tmp.title = title, _tmp.content = content, _tmp.answer = "", _tmp.createdAt = createdAt, _tmp.answeredAt = "", _tmp.status = "대기중", _tmp);
                        return [
                            4,
                            components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_8__/* .projectFirestore.collection */ .H.collection("users").doc(email).collection("inquireReceive")
                        ];
                    case 2:
                        collectionRefAppUser = _state.sent();
                        return [
                            4,
                            collectionRefAppUser.add(values)
                        ];
                    case 3:
                        newDoc = _state.sent();
                        docRefUser = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_8__/* .projectFirestore.collection */ .H.collection("users").doc(settings.email).collection("inquireSend").doc(newDoc.id);
                        docRefApp = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_8__/* .projectFirestore.collection */ .H.collection("gcf").doc(email).collection("app").doc(appId).collection("inquire").doc(newDoc.id);
                        return [
                            4,
                            docRefUser.set(values)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            4,
                            docRefApp.set(values)
                        ];
                    case 5:
                        _state.sent();
                        setTitle("");
                        setContent("");
                        closeModal("");
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)("문의 등록 실패");
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleModalOkButton() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_InquireModal__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        modalVisible: modalVisible,
        closeModal: closeModal,
        handleModalOkButton: handleModalOkButton,
        title: title,
        setTitle: setTitle,
        content: content,
        setContent: setContent
    });
};
/* 신고 모달 */ var ReportModalContent = function(param) {
    var modalVisible = param.modalVisible, setLoginModalVisible = param.setLoginModalVisible, closeModal = param.closeModal, appId = param.appId, appName = param.appName, email = param.email, appUserName = param.appUserName, price = param.price;
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), title = ref[0], setTitle = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), content = ref1[0], setContent = ref1[1];
    var handleModalOkButton = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(function() {
            var date, createdAt, text, text1, collectionRefAppUser, values, _tmp, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        /* 로그인 체크하고 로그인 후 이용해달라고 하기 */ if (!settings.email) {
                            setLoginModalVisible(true);
                            return [
                                2,
                                ""
                            ];
                        }
                        date = new Date();
                        createdAt = (0,components_FormatDate__WEBPACK_IMPORTED_MODULE_22__/* .FormatDate */ .r2)(date);
                        if (title === "") {
                            text = "신고 제목을 입력해주세요.";
                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)(text);
                            return [
                                2
                            ];
                        }
                        if (content === "") {
                            text1 = "신고 내용을 입력해주세요.";
                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)(text1);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_8__/* .projectFirestore.collection */ .H.collection("admin").doc("report").collection("app")
                        ];
                    case 2:
                        collectionRefAppUser = _state.sent();
                        _tmp = {};
                        values = (_tmp.email = settings.email, _tmp.userName = settings.name, _tmp.appId = appId, _tmp.appName = appName, _tmp.appEmail = email, _tmp.appUserName = appUserName, _tmp.price = price, _tmp.title = title, _tmp.content = content, _tmp.createdAt = createdAt, _tmp.status = "미확인", _tmp);
                        return [
                            4,
                            collectionRefAppUser.add(values)
                        ];
                    case 3:
                        _state.sent();
                        // const docRefUser = await projectFirestore.collection("users").doc(settings.email).collection("report").doc(appUserDoc.id);
                        // await docRefUser.set(values);
                        setTitle("");
                        setContent("");
                        closeModal("");
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)("신고 등록 실패");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleModalOkButton() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_ReportModal__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        modalVisible: modalVisible,
        closeModal: closeModal,
        handleModalOkButton: handleModalOkButton,
        title: title,
        setTitle: setTitle,
        content: content,
        setContent: setContent
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AppHeader);


/***/ })

}]);